import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "upsell-mbg",
    templateUrl: "upsell-mbg.html",
    styleUrls: ["upsell-mbg.scss"],
    standalone: false
})

export class UpsellMBGComponent {
  // mbgBadge is never bound from the parent template; it keeps its own static default.
  @Input() mbgBadge: string = '';

  @Input() mbgText: string = '';
  @Input() mbgCTA: boolean = false;
  @Input() productName: string = '';
  @Input() buttonYesText: string = 'Yes I want this special added to my order';
  @Input() buttonNoText: string = 'No thanks, I understand that I won\'t see this offer again';

  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  /** Money-back-guarantee copy; falls back to the default (interpolating productName) when mbgText is empty. */
  get displayMbgText(): string {
    return this.mbgText || `<div class='text-3xl font-bold mt-0'>Money-Back Guarantee</div><p class='mb-0'>As always, you're protected by our 100% Money-Back Guarantee. That means you have a full 90 days to try <b>${this.productName || 'this product'}</b>, and if you are not thrilled with the results - for any reason - simply contact our customer service team for a refund of your purchase price (excludes shipping). No questions asked.</p>`;
  }

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }
}
